import React from 'react';
import me from './../../image/me.png'
import PP from './../../image/PP.jpg'

const AboutMe = () => {
    return (
        <div className=''>
            {/* <div className=' container mx-auto grid grid-cols-2 sm:grid-cols-'>
                <div>
                    <h1>Sajol Bhadra</h1>
                    <h1>sajolbhadra@gmail.com</h1>
                    <h1>+880 01874 41 56 51</h1>
                    <p>I am Sajol Bhadra. I am 23 Years old. I am an Engineering student and a Web Developer, Currently Studying in Bachelor of Science in EEE in Khulna, Bangladesh.
                        My main field of working on Web Delelopment is based on ReactJS. With React i worked with lots of popular CSS frameworks such as Bootstrap, Tailwind and component based library such as MaterialUI, DaisyUI and obviously Vanilla Css.
                        In addition for Backend I worked with NodeJS, ExpressJS and MongoDB for Database.For authentication and hosting i used Firebase also netlify, and Heroku to Server Deploy.

                        I am passionate to Web Development. </p>
                </div>
                <div><img src={me} alt="Sajol Bhadra" /></div>
            </div> */}
            <div className='flex justify-center my-24 container mx-auto text-center  '>
                <div className="card lg:card-side bg-base-100 shadow-xl ">
                    <figure ><img src={PP} alt="Album" /></figure>
                    <div className="card-body content-center items-center">
                        <p className='items-center content-center'>My name is Sajol Bhadra and I am 23 years old. I am currently studying in BSc in EEE in engineering, in Khulna. I am positive and enthusiastic about Web Developing. Learning web development for a year and over the years, I have built up a diverse projects and skilled with different technology like html5 ,css3 , different CSS libraries  like tailwind,bootstrap, material UI,  javascript , a javascript framework react, with different integrations like react router, react hook form, firebase for authentication and hosting, for backend  NodeJS and its framework ExpressJS, for database i have implement MongoDB to my project, etc.</p>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default AboutMe;